import PropTypes from 'prop-types';
import React from 'react';
import FormField from 'lib/FormBuilder/components/FormRenderer/FormField';
import config from 'coeus.config';
import { Grid } from '@material-ui/core';

const AdditionalFields = ({ errors, touched, values }) => {
    const { custom_fields: fields } = config.user;
    return (
        <>
            {fields &&
                fields.map((field, index) => (
                    <Grid item xs={12} sm={6} style={{ marginBottom: '10px' }}>
                        <FormField
                            field={field}
                            index={index}
                            errors={errors}
                            touched={touched}
                            values={values}
                        />
                    </Grid>
                ))}
        </>
    );
};

export default AdditionalFields;

AdditionalFields.propTypes = {
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
};
